import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import auth from './modules/auth';

const reducers = combineReducers({
    routing,
    auth
})

export default reducers;